/** インセンティブ金額の最小値（円） */
export const MIN_INCENTIVE_AMOUNT = 0;

/** インセンティブ金額の最大値（円） */
export const MAX_INCENTIVE_AMOUNT = 100000;

/** 最低勤務時間の最小値（時間） */
export const MIN_WORKING_HOURS = 1;

/** 最低勤務時間の最大値（時間） */
export const MAX_WORKING_HOURS = 24;

/**
 * インセンティブ設定ビジネスポリシー
 */
export const IncentiveSettingPolicy = {
  /**
   * インセンティブ金額が有効な範囲内かどうかを検証
   * @param amount インセンティブ金額
   * @returns 有効な場合はtrue
   */
  isValidIncentiveAmount(amount: number): boolean {
    return (
      Number.isInteger(amount) &&
      amount >= MIN_INCENTIVE_AMOUNT &&
      amount <= MAX_INCENTIVE_AMOUNT
    );
  },

  /**
   * 最低勤務時間が有効な範囲内かどうかを検証
   * @param hours 勤務時間
   * @returns 有効な場合はtrue
   */
  isValidWorkingHours(hours: number): boolean {
    return (
      Number.isInteger(hours) &&
      hours >= MIN_WORKING_HOURS &&
      hours <= MAX_WORKING_HOURS
    );
  },

  /**
   * 日付範囲が有効かどうかを検証
   * 開始日が終了日以前であることを確認
   * @param startDate 開始日（ISO 8601形式: YYYY-MM-DD）
   * @param endDate 終了日（ISO 8601形式: YYYY-MM-DD）
   * @returns 有効な場合はtrue
   */
  isValidDateRange(startDate: string, endDate: string): boolean {
    if (!startDate || !endDate) {
      return false;
    }
    return new Date(startDate) <= new Date(endDate);
  },
};
